module.exports = __webpack_public_path__ + "static/img/7areaA_04.83b4c42.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/7areaA_04.png
// module id = 818
// module chunks = 1